import script from "./DialogFilterMenus.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogFilterMenus.vue?vue&type=script&setup=true&lang=ts"

import "./DialogFilterMenus.vue?vue&type=style&index=0&id=ea7ad4f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea7ad4f8"]])

export default __exports__